import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, CheckCircleIcon } from '@metarouter-private/mr-mui';

export default function ExportComplete({ count }) {
  return (
    <Stack spacing={2} alignItems="center" padding={3}>
      <CheckCircleIcon color="success" fontSize="large" />
      <Typography variant="body1">Successfully exported {count} schemas</Typography>
    </Stack>
  );
}

ExportComplete.propTypes = {
  count: PropTypes.number.isRequired,
};
